import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';

export default function Details() { 
    const { id } = useParams();
    const [ role, setRole ] = useState([]);

    useEffect(() => { 
        axios.post('http://localhost:5000/GetRole', { id: id})
            .then((response) => { 
                setRole(response.data[0]);
            })
            .catch((error) => { 
                console.log(error);
            })
    });

    useEffect(() => { 
        axios.post('http://localhost:5000/Roles/GetRole', { id: id})
            .then((response) => { 
                setRole(response.data[0]);
            })
            .catch((error) => { 
                console.log(error);
            })
    }, [role]);


    return(
        <React.Fragment>
            <main>
                <h1>Role Details</h1>
                
                <section>
                    <article>
                        <Link to="/Admin/Roles" className="btn btn-secondary">Back</Link>
                        <dl>
                            <dt>ID:</dt>
                            <dd>{role._id}</dd>
                            <dt>User ID:</dt>
                            <dd>{role.userId}</dd>
                            <dt>Role:</dt>
                            <dd>{role.name}</dd>
                            <dt>Date Created:</dt>
                            <dd>{role.dateCreated}</dd>
                            <dt>User IP:</dt>
                            <dd>{role.userIp}</dd>
                        </dl>
                    </article>
                </section>
            </main>
        </React.Fragment>
    )
}